import { MatrixTypes } from '../enums/GameEnums';

export const getRandomField = (type) => {
  return Math.floor(Math.random() * (MatrixTypes[type].column))
}